import Firebase from '@firebase/app'
import '@firebase/auth'
import '@firebase/database'
Firebase.initializeApp(__FIREBASE_CONFIG__)

export default Firebase



// WEBPACK FOOTER //
// ./src/Firebase.js